import type { ReactNode } from 'react';

import { LandingPitch } from './LandingPitch';

/**
 * Two-column landing shell. Left column: brand + course pitch.
 * Right column: caller-supplied CTA card.
 */
export function AuthLayout({ right }: { right: ReactNode }) {
  return (
    <div className="login-shell">
      <div className="login-grid">
        <div className="login-left">
          <LandingPitch />
        </div>
        <div className="login-right">{right}</div>
      </div>
    </div>
  );
}
